import { axiosInstance } from "./axiosInstance";

export const AuthService = {
    login: async (email, password) => {
        return await axiosInstance.post('/api/auth/superadmin/login', {
            email: email,
            password: password
        })
    },
    logout: async () => {
        return await axiosInstance.post('/api/auth/superadmin/logout')
    }
}